module.exports = __webpack_public_path__ + "static/media/menu-white.e14d3f6f.svg";